import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { apis } from '../config/api';
import { User } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  http = inject(HttpClient);

  addUser(payload: User) {
    return this.http.post<User>(apis.users, payload);
  }

  getUser(userId: string) {
    return this.http.get<User>(`${apis.users}/${userId}`);
  }

  listUsers(params: { page?: number; limit?: number }) {
    return this.http.get<{ total: number; users: User[] }>(
      apis.users,
      {
        params,
      }
    );
  }

  updateUser(userId: string, payload:any) {
    return this.http.patch<User>(`${apis.users}/${userId}`, payload);
  }

  deleteUser(userId: string) {
    return this.http.delete(`${apis.users}/${userId}`);
  }

  searchStudents(schoolId: string, searchTerm: string) {
    return this.http.get(`${apis.students}/${schoolId}`, {
      params: {
        search: searchTerm,
        limit: 10
      }
    });
  }
}
